/**
 * Section config per sales path for the sticky "Springen zu" sidebar.
 * Each entry: path -> array of { id, label }. id must match an element id in the page.
 */

import { SALES_SERVICES } from "./salesServicesData";
import { getInsightBySlug } from "./insightsData";

const PATH_TO_SERVICE_ID = {
  "/sales/sales-klassisch": "sales-klassisch",
  "/sales/sales-industrie": "sales-industrie",
  "/sales/sales-healthcare": "sales-healthcare",
};

function buildSalesServicePageSections(service) {
  if (!service?.detail) return [];
  const prefix = "service-section";
  const out = [];
  service.detail.sections?.forEach((s, i) => {
    out.push({
      id: `${prefix}-${i}`,
      label: s.shortLabel || (s.heading && s.heading.split(/\s+/).slice(0, 2).join(" ")) || `Abschnitt ${i + 1}`,
    });
  });
  if (service.detail.cta) {
    out.push({
      id: `${prefix}-cta`,
      label: service.detail.cta.shortLabel || "Kontakt",
    });
  }
  return out;
}

function buildInsightDetailSections(article) {
  if (!article?.detail) return [];
  const prefix = "insight-section";
  const out = [];
  article.detail.sections?.forEach((s, i) => {
    const label =
      s.shortLabel ||
      (s.heading && s.heading.split(/\s+/).slice(0, 3).join(" ")) ||
      `Abschnitt ${i + 1}`;
    out.push({ id: `${prefix}-${i}`, label });
  });
  if (article.detail.cta) {
    out.push({ id: `${prefix}-cta`, label: "Kontakt" });
  }
  if (article.detail.bottomImage) {
    out.push({ id: `${prefix}-bottom-image`, label: "Bild" });
  }
  return out;
}

const SALES_HOME_SECTIONS = [
  { id: "section-hero", label: "Start" },
  { id: "section-services", label: "Dienstleistungen" },
  { id: "section-headhunting", label: "Headhunting" },
  { id: "section-team", label: "Team" },
  { id: "section-insights", label: "Einblicke" },
  { id: "section-stats-logos", label: "Partner & Zahlen" },
  { id: "section-contact", label: "Kontakt" },
];

const PATH_SECTIONS = {
  "/sales": SALES_HOME_SECTIONS,
  "/sales/": SALES_HOME_SECTIONS,
  "/sales/geschichte": [
    { id: "section-sales-story", label: "Story" },
    { id: "section-sales-story-contact", label: "Kontakt" },
  ],
  "/sales/team": [
    { id: "section-team", label: "Team" },
    { id: "section-team-contact", label: "Kontakt" },
  ],
  "/sales/insights": [{ id: "section-insights-contact", label: "Einblicke" }],
  "/sales/referenzen": [
    { id: "section-erfolgsgeschichten-contact", label: "Kontakt" },
  ],
  "/sales/awards": [
    { id: "section-auszeichnungen", label: "Auszeichnungen" },
    { id: "section-auszeichnungen-contact", label: "Kontakt" },
  ],
};

export function getSectionsForPath(pathname) {
  if (!pathname || !pathname.startsWith("/sales")) return [];
  const serviceId = PATH_TO_SERVICE_ID[pathname];
  if (serviceId) {
    const service = SALES_SERVICES.find((s) => s.id === serviceId);
    const built = buildSalesServicePageSections(service);
    if (built.length) return built;
  }
  const exact = PATH_SECTIONS[pathname];
  if (exact) return exact;
  if (pathname.startsWith("/sales/insights/")) {
    const slug = pathname.replace(/^\/sales\/insights\/?/, "").split("/")[0];
    const article = getInsightBySlug(slug);
    const built = buildInsightDetailSections(article);
    if (built.length) return built;
    return [{ id: "section-insight-detail", label: "Inhalt" }];
  }
  return [];
}
